// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/assets/css/turnero.css
// module id = 307
// module chunks = 0